import React from 'react';

import Modal from '~components/Modal';
import { Form as WizardForm } from '~components/wizard-form';

import steps from '~support-at-home/forms/statements/new';

interface ComponentProps {
  isOpen: boolean;
  setIsOpen: (toggle: boolean) => void;
}

const StatementsWizard: React.FC<ComponentProps> = ({ isOpen, setIsOpen }) => {
  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="New Statement"
      headerClassName="header"
      className="statements-wizard-modal"
      includeFooter={false}
      unmountOnClose
    >
      <WizardForm steps={steps} onComplete={() => setIsOpen(false)} submitCaption="Close" />
    </Modal>
  );
};

export default StatementsWizard;
